import React from 'react'
import PropTypes from 'prop-types'
import { useIntl, FormattedMessage } from 'react-intl'
import moment from 'moment'
import MasterData from '../../data/MasterData'
import { apiTrainKindClass } from '../../utils/ClassHelper'

const Timetable = ({ timetable, index, changeTimetableCollapsed }) => {
  const intl = useIntl()
  const locale = intl.locale

  const departureTime = (timestamp) => moment.tz(timestamp * 1000, 'Asia/Tokyo').format('HH:mm')

  const delayElement = (delaytime) => {
    if (delaytime !== null && delaytime !== 0) {
      return <span className="d-StationDetail-timetableLate">＋{delaytime}</span>
    }
  }

  const changeCollapse = (isCollapsed) => {
    changeTimetableCollapsed(index, isCollapsed)
  }

  const renderCollapseButton = () => {
    // TODO: デザイン確認(もともと is_close クラスがなく、閉じると書いてあった)
    if (timetable.isCollapsed) {
      return <a className="d-StationDetail-scheduleMore is_close" onClick={() => changeCollapse(false)}></a>
    } else {
      return <a className="d-StationDetail-scheduleMore" onClick={() => changeCollapse(true)}>プラス５件表示</a>
    }
  }

  const showingCount = timetable.isCollapsed ? 7 : 2

  return (
    <div className="d-StationDetail-schedule">
      <div className="d-StationDetail-scheduleHeader">
        {timetable[`toward_${locale}`]}
      </div>
      <div className="d-StationDetail-scheduleContent">
        <table className="d-StationDetail-timetable">
          <thead>
            <tr className="d-StationDetail-timetableHeader">
              <FormattedMessage id='Timetable.trackNo'>
                {(txt) => <th className="is_sm">{txt}</th>}
              </FormattedMessage>
              <FormattedMessage id='Timetable.trainKind'>
                {(txt) => <th className="is_md">{txt}</th>}
              </FormattedMessage>
              <FormattedMessage id='Timetable.destination'>
                {(txt) => <th className="is_lg">{txt}</th>}
              </FormattedMessage>
              <FormattedMessage id='Timetable.depTime'>
                {(txt) => <th className="is_md">{txt}</th>}
              </FormattedMessage>
              <FormattedMessage id='Timetable.cars'>
                {(txt) => <th className="is_sm">{txt}</th>}
              </FormattedMessage>
            </tr>
          </thead>
          <tbody>
            {timetable.trains.slice(0, showingCount).map((train, i) => {
              const stopKind = MasterData.trainKindById(train[`kind`])
              return (
                <tr className="d-StationDetail-timetableRow" key={`schedule${i}`}>
                  <td>{train.platform}</td>
                  <td>
                    <span className={`d-StationDetail-timetableType ${apiTrainKindClass(train)}`} >
                      <span>{stopKind[`station_detail_name_${locale}`]}</span>
                    </span>
                  </td>
                  <td>{train[`destination_station_name_${locale}`]}</td>
                  <td>{departureTime(train.time)}{delayElement(train.delay)}</td>
                  <td>{train.train_length}</td>
                </tr>
              )
            })}
          </tbody>
        </table>{/* /.d-StationDetail-timetable */}
        {renderCollapseButton()}
      </div>{/* /.d-StationDetail-scheduleContent */}
    </div>
  )
}

Timetable.propTypes = {
  timetable: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  changeTimetableCollapsed: PropTypes.func.isRequired,
}

export default Timetable
